export class AccountNotFoundException extends Error {}
